import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

import './style.scss';

const DatePicker = ({ field, Controller, control, showLabel }) => {
  return (
    <div className="filter-input date-picker">
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Controller
          name={field?.name}
          control={control}
          defaultValue={null}
          render={({ field: { onChange, value } }) => (
            <DesktopDatePicker
              value={value}
              defaultValue={null}
              label={showLabel ? field.label : ''}
              inputFormat={'dd/MM/yyyy'}
              onChange={(value) => onChange(value)}
              renderInput={(params) => (
                <TextField
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    disableUnderline: true
                  }}
                  {...params}
                />
              )}
            />
          )}
        />
      </LocalizationProvider>
    </div>
  );
};

export default DatePicker;

DatePicker.propTypes = {
  field: PropTypes.object,
  Controller: PropTypes.any,
  control: PropTypes.any,
  showLabel: PropTypes.bool
};
